import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CreateLeagueWeekRequest } from '../../../models/createleagueweekrequest';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { GolfEventService } from '../../../services/golf-event.service';
import { toCalendarControlFriendlyDate } from '../../../util/dateutil';

@Component({
  selector: 'app-create-week',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './create-week.component.html',
  styleUrl: './create-week.component.css'
})
export class CreateWeekComponent {
  constructor(private golfEventService:GolfEventService) {}

  @Input() golfEventId:number|null = null;
  @Output() saved = new EventEmitter<void>();

  createLeagueWeekRequest:CreateLeagueWeekRequest = {
    gimmeCircleSize: 12,
    golfCourseName: '',
    holesToPlay: 'FRONT9',
    pinLocations: 'Thursday',
    teeLocation: '',
    weekEndDate: this.getDefaultEndDate(),
    weekStartDate: this.getDefaultStartDate(),
    golfEventId: -1
  }

  async save() {
    if(!this.golfEventId) return;
    this.createLeagueWeekRequest.golfEventId = this.golfEventId;
    await this.golfEventService.createLeagueWeek(this.createLeagueWeekRequest);
    this.saved.emit();
  }

  getDefaultStartDate():string {
    let dte = new Date();
    return toCalendarControlFriendlyDate(dte);
  }

  getDefaultEndDate():string {
    let dte = new Date();
    return toCalendarControlFriendlyDate(dte);
  }
}
